'use client'

import { useEffect, useState } from 'react'
import { Minus, Plus } from 'lucide-react'
import useCommonStore from '@/store/commonStore'
import { useRouter, useSearchParams } from 'next/navigation'

interface WebFilterProps {
  // selectedFilters: Record<string, string[]>
  // setSelectedFilters: React.Dispatch<React.SetStateAction<Record<string, string[]>>>
}



export function WebFilter({ }: WebFilterProps) {
  const [open, setOpen] = useState<{ [key: string]: any }>({})
  const { filterData, sortData } = useCommonStore()
  const searchParams = useSearchParams()
  const router = useRouter()

  const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>({})
  const [selectedSort, setSelectedSort] = useState<Record<string, string>>({})

  const handleApply = (obj?: Record<string, string[]>) => {
    const sp = new URLSearchParams()
    searchParams.forEach((v, k) => {
      if (!k.startsWith('f_')) {
        sp.set(k, v)
      }
    })
    let fltrObj = obj ? obj : selectedFilters
    Object.keys(fltrObj).forEach((key) => {
      if (fltrObj[key]?.length > 0) {
        sp.set(`f_${key}`, fltrObj[key].join('-'))
      }
    })
    router.replace(`?${sp.toString()}`)
  }


  const filterAndSort = () => {
    let fltr: Record<string, string[]> = {}
    let sort: Record<string, string> = {}
    searchParams?.forEach((value, key) => {
      if (key.startsWith("f_")) {
        const filterKey = key.slice(2)
        fltr[filterKey] = value.split('-')
      } else if (key.startsWith("s_")) {
        const sortKey = key.slice(2)
        sort[sortKey] = value
      }
    })
    setSelectedFilters(fltr)
    setSelectedSort(sort)
    return { fltr, sort }
  }
  useEffect(() => {
    filterAndSort()
  }, [searchParams])

  const handleSortApply = (key: string, value: string) => {
    const sp = new URLSearchParams()
    searchParams.forEach((v, k) => {
      if (!k.startsWith('s_')) {
        sp.set(k, v)
      }
    })
    if (value) {
      sp.set(`s_${key}`, value)
      setSelectedSort({ [key]: value })
    }
    router.replace(`?${sp.toString()}`)
  }

  const handleFilterReset = () => {
    setSelectedFilters({})
    const sp = new URLSearchParams()
    searchParams.forEach((value, key) => {
      if (key.startsWith('f_') ) {
        sp.delete(key)
      } else {
        sp.set(key, value)
      }
    })
    router.replace(`?${sp.toString()}`)
  }
    const handleSortReset = () => {
    setSelectedSort({})
    const sp = new URLSearchParams()
    searchParams.forEach((value, key) => {
      if (key.startsWith('s_')) {
        sp.delete(key)
      } else {
        sp.set(key, value)
      }
    })
    router.replace(`?${sp.toString()}`)
  }




  return (
    <aside className="pr-4">
      {/* Sort Section */}
      {sortData?.length > 0 && (
        <div className="mb-6">
          <div className="mb-4 flex items-center justify-between">
            <span className="font-semibold">Sort By</span>
            <button
                className="text-xs text-primary underline"
                onClick={() => handleSortReset()}
              >
                Clear all
              </button>
          </div>
          <div className="space-y-2">
            
            {sortData.map((option, idx) => (
              <label key={option.key + idx} className="flex items-center gap-2 text-primary text-sm py-1">
                <input
                  type="radio"
                  name="sort"
                  checked={selectedSort[option.key] === option.value}
                  onChange={() => handleSortApply(option.key, option.value)}
                  className="accent-primary"
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>
      )}
      {/* Filter Section */}
      <div className="mb-4 flex items-center justify-between">
        <span className="font-semibold">Filters</span>
        <button
          className="text-xs text-primary underline"
          onClick={() => handleFilterReset()}
        >
          Clear all
        </button>
      </div>
      <div className="space-y-6">
        {filterData.map((filter, idx) => (
          <div key={filter.key + idx}>
            <div className="flex items-center justify-between py-2 border-b">
              <span className="font-medium">{filter.label}</span>
              <button
                className="text-lg text-primary font-bold transition-transform duration-200"
                onClick={() => open?.key === filter.key ? setOpen({}) : setOpen(filter)}
                aria-label={open?.key == filter.key && open.label == filter.label ? 'Collapse' : 'Expand'}
              >
                {open?.key == filter.key && open.label == filter.label ? (
                  <Minus className="w-5 h-5 transition-transform duration-200 rotate-0" />
                ) : (
                  <Plus className="w-5 h-5 transition-transform duration-200 rotate-90" />
                )}
              </button>
            </div>
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out`}
              style={{
                maxHeight: open?.key == filter.key && open.label == filter.label ? `${filter.items.length * 40}px` : '0px',
                opacity: open?.key == filter.key && open.label == filter.label ? 1 : 0,
                scrollBehavior: 'smooth',
              }}
            >
              <div className="flex flex-col gap-2 py-2 pl-2">
                {open?.items?.map((option: any, idx: number) => (
                  <label key={option.value + idx} className="flex items-center gap-2 text-primary text-sm">
                    <input
                      type="checkbox"
                      checked={selectedFilters[filter.key]?.includes(option.value) || false}
                      onChange={() => {
                        let obj = {}
                        if (selectedFilters[filter.key]?.includes(option.value)) {
                          obj = {
                            ...selectedFilters,
                            [filter.key]: selectedFilters[filter.key]?.filter(v => v !== option.value) || []
                          }
                        } else {
                          obj = {
                            ...selectedFilters,
                            [filter.key]: [...(selectedFilters[filter.key] || []), option.value]
                          }
                        }
                        setSelectedFilters(obj)
                        handleApply(obj)
                      }}
                      className="accent-primary"
                    />
                    {option.label}
                  </label>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </aside>
  )
}